import Breadcrumbs from '../components/Breadcrumbs';
import { icons } from '../components/Icons';
import { AuthenticatedLayout } from '../components/Layout/AuthenticatedLayout';
import { trpc } from '../lib/trpc';
import { standardSchemaResolver } from '@hookform/resolvers/standard-schema';
import { Button, Container, Space, TextInput } from '@mantine/core';
import { showNotification } from '@mantine/notifications';
import { useForm } from 'react-hook-form';
import { z } from 'zod/v4';

const schema = z.object({
  email: z.email(),
});

export const Invite = () => {
  const {
    formState: { errors, isSubmitting },
    handleSubmit,
    register,
    reset,
    setError,
  } = useForm<z.infer<typeof schema>>({
    resolver: standardSchemaResolver(schema),
  });

  const { mutateAsync: sendInviteAsync } =
    trpc.profile.sendInvite.useMutation();

  const submitHandler = handleSubmit(async (data) => {
    const response = await sendInviteAsync({ email: data.email });
    if (response.ok) {
      showNotification({
        message: (
          <>
            <icons.Success /> Invite sent
          </>
        ),
      });
      reset();
    } else {
      setError('email', {
        message: response.error || 'Something went wrong. Try again later',
      });
    }
  });

  return (
    <AuthenticatedLayout>
      <Container size="md">
        <Breadcrumbs items={[{ '/': 'Home' }, 'Send Invite']} />
        <Container
          size="xs"
          style={{ padding: 40 }}
        >
          <form
            noValidate
            onSubmit={submitHandler}
          >
            <TextInput
              error={errors?.email?.message?.toString()}
              label="Email address"
              type="email"
              {...register('email')}
            />
            <Space h="md" />
            <Button
              loading={isSubmitting}
              type="submit"
            >
              Send
            </Button>
          </form>
        </Container>
      </Container>
    </AuthenticatedLayout>
  );
};
